import Color from 'color';
import { Colors } from '@capcenter/shared';

const Shadows = {
  dropdown: '0px 5px 13px 0px ' + Color(Colors?.black500).fade(0.7),
};

export default Shadows;
